/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import React, { Component } from "react";
import AuthService from "./authService";
import { connect } from "react-redux";
import actionTypes from "../store/actions";
import Loader from "../component/loader";
import BusApiCall from "../helper/axios.js";
import constants from "../helper/constants";
import store from "../store/store";
import { getAppDomain } from "../helper/getAppDomain.js";
import { withNavigation } from "../helper/withNavigation.js";

var absoluteDomain = getAppDomain() || "";

class Login extends Component {
  state = {
    tenantId: "",
  };

  componentDidMount() {
    this.props.setCompDidMount();
    let searchOptions = window.location.search;
    sessionStorage.setItem(
      "redirectUrl",
      window.location.pathname + (searchOptions ? searchOptions : ""),
    );
    let tokenInfo = JSON.parse(localStorage.getItem("tokenInfo"));
    let doLogin = JSON.parse(localStorage.getItem("doLogin"));
    if (tokenInfo || doLogin) {
      this.login();
      window.localStorage.setItem("doLogin", false);
    } else {
      window.localStorage.setItem("doLogin", false);
      if (this.props.tenantInfo && this.props.tenantInfo.clientId) {
        this.login();
      } else {
        // this.props.router.navigate('/login');
        setTimeout(() => {
          this.props.router.navigate("/login", { replace: true });
        }, 0);
      }
      // BusApiCall('GET', `${constants.busInternalUrl}/tenants/${this.state.tenantId}/themes`).then(theme => {
      //     let tenantData = {};
      //     for (var i = 0; i < theme.data.length; i++) {
      //         tenantData[theme.data[i].key] = theme.data[i].value
      //     }
      //     this.setState({
      //         providerTitle: tenantData.title
      //     })
      //     let publicBrowsing = true;
      //     this.props.setPublicBrowsing(publicBrowsing)
      //     this.props.setTenantData(tenantData)
      //     this.props.setTenantId(this.state.tenantId)

      // }).catch(error => {
      //     console.log('error sales channel', error)
      //     this.login();
      // })
    }
  }

  login() {
    if (window.self === window.top) {
      let tokenInfo = JSON.parse(localStorage.getItem("tokenInfo"));
      let expired = false;
      let userRoleFound = true;
      let userRoles = JSON.parse(localStorage.getItem("roles"));
      if (tokenInfo) {
        if (tokenInfo.expires_at) {
          if (tokenInfo.expires_at * 1000 < Date.now()) {
            expired = true;
          } else {
            expired = false;
          }
        } else {
          // expired = true;
          AuthService.signinRedirect()
            .then()
            .catch((e) => {
              console.log(e);
            });
          return;
        }
      } else {
        // expired = true;
        AuthService.signinRedirect()
          .then()
          .catch((e) => {
            console.log(e);
          });
        return;
      }
      if (userRoles) {
        userRoleFound = true;
      } else {
        // userRoleFound = false;
        AuthService.signinRedirect()
          .then()
          .catch((e) => {
            console.log(e);
          });
        return;
      }
      if (expired || !userRoleFound) {
        let doLogin = JSON.parse(localStorage.getItem("doLogin"));
        // if (!doLogin) {
        //     localStorage.clear();
        // }
        AuthService.signinSilent()
          .then((res) => {
            this.props.authenticate(res);
            BusApiCall(
              "GET",
              `${constants.busInternalUrl}/loggedInUserPermission`,
            )
              .then((userRoles) => {
                if (
                  window.location.protocol === "https:" ||
                  window.location.protocol === "HTTPS:"
                ) {
                  document.cookie =
                    "user_login_id=" +
                    userRoles.data.loggedInUser.userId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                  document.cookie =
                    "tenantId=" +
                    userRoles.data.tenantId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                  document.cookie =
                    "sharedToken=true; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                  document.cookie =
                    "tenantInfo=" +
                    JSON.stringify(this.props.tenantInfo) +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                } else {
                  document.cookie =
                    "user_login_id=" +
                    userRoles.data.loggedInUser.userId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/;";
                  document.cookie =
                    "tenantId=" +
                    userRoles.data.tenantId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/;";
                  document.cookie =
                    "sharedToken=true; domain=" + absoluteDomain + "; path=/;";
                  document.cookie =
                    "tenantInfo=" +
                    JSON.stringify(this.props.tenantInfo) +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/;";
                }
                localStorage.setItem("roles", JSON.stringify(userRoles));
                localStorage.setItem(
                  "modules",
                  JSON.stringify(userRoles.data.modules),
                );
                this.props.setModules(userRoles.data.modules);
                this.props.setDefaultCountry(userRoles.data.defaultCountry || "USA");
                this.props.setEnabledFeatures(userRoles.data.features || {});
                let tenantId = userRoles.data.tenantId;
                if (userRoles.data.locale) {
                  this.props.setTenantLocale(userRoles.data.locale.trim());
                }
                this.props.setPublicBrowsing(false);

                for (var i = 0; i < userRoles.data.securityGroups.length; i++) {
                  if (
                    userRoles.data.securityGroups[i].securityGroup.includes(
                      "ECOMMERCE_CUSTOMER",
                    ) ||
                    userRoles.data.securityGroups[i].securityGroup.includes(
                      "ECOMMERCE_ADMIN",
                    )
                  ) {
                    BusApiCall(
                      "GET",
                      `${constants.busV4Url}/myProfile?customerId=`,
                    ).then((res) => {
                      this.props.setEcommerceCustData(res.data);
                    });
                    break;
                  }
                }
                if (
                  userRoles.data.loggedInUser.permissions.includes(
                    "CUMULATOR-REPORT_VIEW",
                  )
                ) {
                  BusApiCall(
                    "GET",
                    `${constants.genericReportUrl}?reportName=${"getAvailableReports"}`,
                  ).then((res) => {
                    if (
                      res.data &&
                      res.data.reportDataJson &&
                      res.data.reportDataJson.reportData
                    ) {
                      this.props.setGenericReports(
                        res.data.reportDataJson.reportData,
                      );
                    } else {
                      this.props.setGenericReports([]);
                    }
                  });
                } else {
                  this.props.setGenericReports([]);
                }

                BusApiCall(
                  "GET",
                  `${constants.busInternalUrl}/tenants/${tenantId}/themes`,
                )
                  .then((salesChannelData) => {
                    BusApiCall(
                      "GET",
                      `${constants.busV44UrlPublic}/tenant/${tenantId}/currency`,
                    ).then((currency) => {
                      localStorage.setItem(
                        "tenantCurrency",
                        JSON.stringify(currency.data),
                      );
                    });
                    var tenantDataTemp = JSON.parse(
                      localStorage.getItem("roles"),
                    );
                    var payload = {
                      partyId: tenantDataTemp.data.loggedInUser.partyId
                        ? tenantDataTemp.data.loggedInUser.partyId
                        : "",
                    };
                    BusApiCall(
                      "POST",
                      `${constants.busInternalUrl}/passthru/GET_PENDING_TASKS_COUNT/endpoint`,
                      payload,
                    )
                      .then((res) => {
                        console.log(
                          "check task count",
                          res.data.pendingTasksCount,
                        );
                        this.props.setPendingTaskCount(
                          res.data.pendingTasksCount,
                        );
                      })
                      .catch((err) => {
                        // if (err.response && err.response.data && err.response.data.message) {
                        //     this.props.setErrorMessage(err.response.data.message, false);
                        // } else {
                        //     this.props.setErrorMessage(this.props.t("DEFAULT_ERROR_MESSAGE"), false);
                        // }
                      });
                    let tenantData = {};
                    for (var i = 0; i < salesChannelData.data.length; i++) {
                      tenantData[salesChannelData.data[i].key] =
                        salesChannelData.data[i].value;
                    }
                    if (tenantData["menuOrientation"]) {
                      if (
                        tenantData["menuOrientation"].toLowerCase() === "top"
                      ) {
                        localStorage.setItem("sideMenu", false);
                        localStorage.setItem("showBucketsOnLeft", false);
                        this.props.setSideMenu(false);
                      } else {
                        localStorage.setItem("sideMenu", true);
                        localStorage.setItem("showBucketsOnLeft", true);
                        this.props.setSideMenu(true);
                      }
                    } else {
                      localStorage.setItem("sideMenu", true); //fallback value incase menuorientaion key is missing is on the Left
                      localStorage.setItem("showBucketsOnLeft", true);
                      this.props.setSideMenu(true);
                    }
                    if (tenantData["showMyCustomerEnabled"]) {
                      localStorage.setItem(
                        "showMyCustomerEnabled",
                        tenantData["showMyCustomerEnabled"] === true
                          ? "true"
                          : "false",
                      );
                    } else {
                      localStorage.setItem("showMyCustomerEnabled", "false");
                    }

                    // localStorage.setItem('sideMenu', false);
                    // localStorage.setItem('showBucketsOnLeft', false);

                    this.props.setTenantData(tenantData);
                    let finalRes = {
                      ...res,
                      userRoles: { ...userRoles },
                    };
                    this.props.authenticate(finalRes);
                    this.props.setTenantId(tenantId);

                    this.props.router.navigate(
                      localStorage.getItem("redirectUrl"),
                    );
                  })
                  .catch((error) => {
                    console.log("error sales channel", error);
                  });
              })
              .catch((error) => {
                if (
                  error &&
                  error.response &&
                  (error.response.status === 500 ||
                    error.response.status === 401 ||
                    error.response.status === 404)
                ) {
                  var Cookies = document.cookie.split(";");
                  for (var i = 0; i < Cookies.length; i++) {
                    if (
                      window.location.protocol === "https:" ||
                      window.location.protocol === "HTTPS:"
                    ) {
                      document.cookie =
                        Cookies[i].split("=")[0] +
                        "=; path=/; domain=" +
                        absoluteDomain +
                        "; secure; expires=" +
                        new Date(0).toUTCString();
                    } else {
                      document.cookie =
                        Cookies[i].split("=")[0] +
                        "=; path=/; domain=" +
                        absoluteDomain +
                        ";  expires=" +
                        new Date(0).toUTCString();
                    }
                  }

                  localStorage.clear();
                  AuthService.signoutRedirect();
                }
              });
          })
          .catch((e) => {
            // AuthService.signinRedirect().then()
            //     .catch(e => {
            //         console.log(e)
            //     })
            // AuthService.getUser()
            //     .then((user) => {
            //         console.log('check new user data', user);
            //     });
            // console.log('here i am mmmmmmmm', JSON.stringify(e), e)
            var Cookies = document.cookie.split(";");
            for (var i = 0; i < Cookies.length; i++) {
              document.cookie =
                Cookies[i].split("=")[0] +
                "=; path=/; domain=" +
                absoluteDomain +
                ";  expires=" +
                new Date(0).toUTCString();
            }

            localStorage.clear();
            this.props.router.navigate("/login");
          });
      } else {
        let themeData = JSON.parse(localStorage.getItem("themeData"));

        let tenantId = userRoles.data.tenantId;
        if (userRoles.data.locale) {
          this.props.setTenantLocale(userRoles.data.locale.trim());
        }
        let tenantData = {};
        if (themeData == null) {
          localStorage.clear();
          window.location.reload();
        } else {
          for (var i = 0; i < themeData.data.length; i++) {
            tenantData[themeData.data[i].key] = themeData.data[i].value;
          }
        }
        if (tenantData["menuOrientation"]) {
          if (tenantData["menuOrientation"].toLowerCase() === "top") {
            localStorage.setItem("sideMenu", false);
            localStorage.setItem("showBucketsOnLeft", false);
          } else {
            localStorage.setItem("sideMenu", true);
            localStorage.setItem("showBucketsOnLeft", true);
          }
        } else {
          localStorage.setItem("sideMenu", true); //fallback value incase menuorientaion key is missing is on the Left
          localStorage.setItem("showBucketsOnLeft", true);
        }

        // localStorage.setItem('sideMenu', false);
        // localStorage.setItem('showBucketsOnLeft', false);

        this.props.setTenantData(tenantData);
        this.props.setTenantId(tenantId);
        let finalRes = {
          ...tokenInfo,
          userRoles: { ...userRoles },
        };
        this.props.authenticate(finalRes);
      }
    }
  }

  render() {
    return <Loader loading={true} top={"40%"} />;
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.authenticated,
    publicBrowsing: state.auth.publicBrowsing,
    tenantInfo: state.auth.tenantInfo,
    tenantInfo: state.auth.tenantInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (profile) =>
      dispatch({ type: actionTypes.AUTHENTICATE, profile }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setTenantId: (id) => dispatch({ type: actionTypes.SET_TENANT_ID, id }),
    setTenantData: (data) =>
      dispatch({ type: actionTypes.SET_TENANT_DATA, data }),
    setTenantLocale: (locale) =>
      dispatch({ type: actionTypes.SET_TENANT_LOCALE, locale }),
    setPublicBrowsing: (data) =>
      dispatch({ type: actionTypes.SET_PUBLIC_BROWSING, data }),
    setEcommerceCustData: (data) =>
      dispatch({ type: actionTypes.ECOMMERCE_CUST_DATA, data }),
    setGenericReports: (data) =>
      dispatch({ type: actionTypes.SET_GENERIC_REPORTS, data }),
    setPendingTaskCount: (data) =>
      dispatch({ type: actionTypes.SET_PENDING_TASK_COUNT, data }),
    setModules: (data) => dispatch({ type: actionTypes.SET_MODULES, data }),
    setSideMenu: (data) => dispatch({ type: actionTypes.SET_SIDE_MENU, data }),
    setDefaultCountry: (data) => dispatch({ type: actionTypes.SET_DEFAULT_COUNTRY, data }),
    setEnabledFeatures: (data) => dispatch({ type: actionTypes.SET_ENABLED_FEATURES, data }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNavigation(Login));
